export const TYPES = {
    SHOW_GATED_MEASURE_NOTICE_POPUP: 'SHOW_GATED_MEASURE_NOTICE_POPUP',
    HIDE_GATED_MEASURE_NOTICE_POPUP: 'HIDE_GATED_MEASURE_NOTICE_POPUP',
    SHOW_GRADE_NOT_AVAILABLE_POPUP: 'SHOW_GRADE_NOT_AVAILABLE_POPUP',
    HIDE_GRADE_NOT_AVAILABLE_POPUP: 'HIDE_GRADE_NOT_AVAILABLE_POPUP',
    SHOW_D8_ALTERNATE_FORM_SELECTION_POPUP: 'SHOW_D8_ALTERNATE_FORM_SELECTION_POPUP',
    HIDE_D8_ALTERNATE_FORM_SELECTION_POPUP: 'HIDE_D8_ALTERNATE_FORM_SELECTION_POPUP',
    SHOW_LECTURA_ALT_FORM_SELECTION_POPUP: 'SHOW_LECTURA_ALT_FORM_SELECTION_POPUP',
    HIDE_LECTURA_ALT_FORM_SELECTION_POPUP: 'HIDE_LECTURA_ALT_FORM_SELECTION_POPUP',
    SHOW_VOC_ASSESS_NOTICE_POPUP: 'SHOW_VOC_ASSESS_NOTICE_POPUP',
    HIDE_VOC_ASSESS_NOTICE_POPUP: 'HIDE_VOC_ASSESS_NOTICE_POPUP',
    SHOW_CS_FORM_SELECTION_POPUP: 'SHOW_CS_FORM_SELECTION_POPUP',
    HIDE_CS_FORM_SELECTION_POPUP: 'HIDE_CS_FORM_SELECTION_POPUP',
    SHOW_BURST_ALT_FORM_SELECTION_POPUP: 'SHOW_BURST_ALT_FORM_SELECTION_POPUP',
    HIDE_BURST_ALT_FORM_SELECTION_POPUP: 'HIDE_BURST_ALT_FORM_SELECTION_POPUP',
    SHOW_PM_FORM_SELECTION_POPUP: 'SHOW_PM_FORM_SELECTION_POPUP',
    HIDE_PM_FORM_SELECTION_POPUP: 'HIDE_PM_FORM_SELECTION_POPUP',
    SHOW_MAZE_SCORE_POPUP: 'SHOW_MAZE_SCORE_POPUP',
    HIDE_MAZE_SCORE_POPUP: 'HIDE_MAZE_SCORE_POPUP',
    SHOW_CP_SCORE_POPUP: 'SHOW_CP_SCORE_POPUP',
    HIDE_CP_SCORE_POPUP: 'HIDE_CP_SCORE_POPUP',
    SHOW_AI_NO_DETAILS_AVAILABLE_POPUP_POPUP: 'SHOW_AI_NO_DETAILS_AVAILABLE_POPUP',
    HIDE_AI_NO_DETAILS_AVAILABLE_POPUP_POPUP: 'HIDE_AI_NO_DETAILS_AVAILABLE_POPUP',
    SHOW_LECTURA_NO_DETAILS_AVAILABLE_POPUP: 'SHOW_LECTURA_NO_DETAILS_AVAILABLE_POPUP',
    HIDE_LECTURA_NO_DETAILS_AVAILABLE_POPUP: 'HIDE_LECTURA_NO_DETAILS_AVAILABLE_POPUP',
    SHOW_NO_RESULT_DETAILS_POPUP: 'SHOW_NO_RESULT_DETAILS_POPUP',
    SHOW_NO_DETAILS_AVAILABLE_POPUP: 'SHOW_NO_DETAILS_AVAILABLE_POPUP',
    HIDE_NO_DETAILS_AVAILABLE_POPUP: 'HIDE_NO_DETAILS_AVAILABLE_POPUP',
    SHOW_UNOFFICIAL_RESULT_POPUP: 'SHOW_UNOFFICIAL_RESULT_POPUP',
    HIDE_OFFICIALNESS_POPUP: 'HIDE_OFFICIALNESS_POPUP',
    SHOW_CREATE_PRESUMED_RESULT_POPUP: 'SHOW_CREATE_PRESUMED_RESULT_POPUP',
    HIDE_CREATE_PRESUMED_RESULT_POPUP: 'HIDE_CREATE_PRESUMED_RESULT_POPUP',
    SHOW_DELETE_PRESUMED_RESULT_POPUP: 'SHOW_DELETE_PRESUMED_RESULT_POPUP',
    HIDE_DELETE_PRESUMED_RESULT_POPUP: 'HIDE_DELETE_PRESUMED_RESULT_POPUP',
    SHOW_ORF_G5_BOY_FORM_POPUP: 'SHOW_ORF_G5_BOY_FORM_POPUP',
    HIDE_ORF_G5_BOY_FORM_POPUP: 'HIDE_ORF_G5_BOY_FORM_POPUP',
    ENABLE_VISIBILITY_ORF_G5_BOY_FORM_POPUP: 'ENABLE_VISIBILITY_ORF_G5_BOY_FORM_POPUP',
    SHOW_ORF_G5_PM_FORM1_ALT_TEXT_POPUP: 'SHOW_ORF_G5_PM_FORM1_ALT_TEXT_POPUP',
    HIDE_ORF_G5_PM_FORM1_ALT_TEXT_POPUP: 'HIDE_ORF_G5_PM_FORM1_ALT_TEXT_POPUP',
    SHOW_DIGITAL_FORMS_POPUP: 'SHOW_DIGITAL_FORMS_POPUP',
    HIDE_DIGITAL_FORMS_POPUP: 'HIDE_DIGITAL_FORMS_POPUP',
    ENABLE_VISIBILITY_DIGITAL_FORMS_POPUP: 'ENABLE_VISIBILITY_DIGITAL_FORMS_POPUP',
    SHOW_TRC_OUTSIDE_BM_POPUP: 'SHOW_TRC_OUTSIDE_BM_POPUP',
    HIDE_TRC_OUTSIDE_BM_POPUP: 'HIDE_TRC_OUTSIDE_BM_POPUP',
    SHOW_NO_IDEL_SUPPORT_POPUP: 'SHOW_NO_IDEL_SUPPORT_POPUP',
    HIDE_NO_IDEL_SUPPORT_POPUP: 'HIDE_NO_IDEL_SUPPORT_POPUP',
};

export const showGatedMeasureNoticePopup = dispatch => payload => {
    dispatch({ type: TYPES.SHOW_GATED_MEASURE_NOTICE_POPUP, payload });
};

export const hideGatedMeasureNoticePopup = dispatch => () => {
    dispatch({ type: TYPES.HIDE_GATED_MEASURE_NOTICE_POPUP });
};

export const showGradeNotAvailablePopup = dispatch => payload => {
    dispatch({ type: TYPES.SHOW_GRADE_NOT_AVAILABLE_POPUP, payload });
};

export const hideGradeNotAvailablePopup = dispatch => () => {
    dispatch({ type: TYPES.HIDE_GRADE_NOT_AVAILABLE_POPUP });
};

export const showD8AlternateFormSelectionPopup = dispatch => payload => {
    dispatch({ type: TYPES.SHOW_D8_ALTERNATE_FORM_SELECTION_POPUP, payload });
};

export const showLecturaAltFormSelectionPopup = dispatch => payload => {
    dispatch({ type: TYPES.SHOW_LECTURA_ALT_FORM_SELECTION_POPUP, payload });
};

export const hideLecturaAltFormSelectionPopup = dispatch => () => {
    dispatch({ type: TYPES.HIDE_LECTURA_ALT_FORM_SELECTION_POPUP });
};

export const hideD8AlternateFormSelectionPopup = dispatch => () => {
    dispatch({ type: TYPES.HIDE_D8_ALTERNATE_FORM_SELECTION_POPUP });
};

export const showOptionalAssessNoticePopup = dispatch => payload => {
    dispatch({ type: TYPES.SHOW_VOC_ASSESS_NOTICE_POPUP, payload });
};

export const hideOptionalAssessNoticePopup = dispatch => () => {
    dispatch({ type: TYPES.HIDE_VOC_ASSESS_NOTICE_POPUP });
};

export const showCSFormSelectionPopup = dispatch => payload => {
    dispatch({ type: TYPES.SHOW_CS_FORM_SELECTION_POPUP, payload });
};

export const hideCSFormSelectionPopup = dispatch => () => {
    dispatch({ type: TYPES.HIDE_CS_FORM_SELECTION_POPUP });
};

export const showBurstAltFormSelectionPopup = dispatch => payload => {
    dispatch({ type: TYPES.SHOW_BURST_ALT_FORM_SELECTION_POPUP, payload });
};

export const hideBurstAltFormSelectionPopup = dispatch => () => {
    dispatch({ type: TYPES.HIDE_BURST_ALT_FORM_SELECTION_POPUP });
};

export const showPMFormSelectionPopup = dispatch => payload => {
    dispatch({ type: TYPES.SHOW_PM_FORM_SELECTION_POPUP, payload });
};

export const hidePMFormSelectionPopup = dispatch => () => {
    dispatch({ type: TYPES.HIDE_PM_FORM_SELECTION_POPUP });
};

export const showMazeScorePopup = dispatch => () => {
    dispatch({ type: TYPES.SHOW_MAZE_SCORE_POPUP });
};

export const hideMazeScorePopup = dispatch => () => {
    dispatch({ type: TYPES.HIDE_MAZE_SCORE_POPUP });
};

export const showCPScorePopup = dispatch => () => {
    dispatch({ type: TYPES.SHOW_CP_SCORE_POPUP });
};

export const hideCPScorePopup = dispatch => () => {
    dispatch({ type: TYPES.HIDE_CP_SCORE_POPUP });
};

export const showAINoDetailsAvailablePopup = dispatch => () => {
    dispatch({ type: TYPES.SHOW_AI_NO_DETAILS_AVAILABLE_POPUP_POPUP });
};

export const hideAINoDetailsAvailablePopup = dispatch => () => {
    dispatch({ type: TYPES.HIDE_AI_NO_DETAILS_AVAILABLE_POPUP_POPUP });
};

export const showLecturaNoDetailsAvailablePopup = dispatch => () => {
    dispatch({ type: TYPES.SHOW_LECTURA_NO_DETAILS_AVAILABLE_POPUP });
};

export const hideLecturaNoDetailsAvailablePopup = dispatch => () => {
    dispatch({ type: TYPES.HIDE_LECTURA_NO_DETAILS_AVAILABLE_POPUP });
};

export const showOfficialnessPopup = dispatch => (
    officialnessInfo,
    navigationDetails = {},
    onNavigateToResult = null,
) => {
    let type;

    if (officialnessInfo.canReviewUnofficial) {
        type = TYPES.SHOW_UNOFFICIAL_RESULT_POPUP;
    } else {
        type = TYPES.SHOW_NO_RESULT_DETAILS_POPUP;
    }

    dispatch({
        type,
        payload: {
            ...officialnessInfo,
            navigationDetails,
            onNavigateToResult,
        },
    });
};

export const hideOfficialnessPopup = dispatch => () =>
    dispatch({ type: TYPES.HIDE_OFFICIALNESS_POPUP });

export const showNoDetailsAvailablePopup = dispatch => () =>
    dispatch({ type: TYPES.SHOW_NO_DETAILS_AVAILABLE_POPUP });

export const hideNoDetailsAvailablePopup = dispatch => () =>
    dispatch({ type: TYPES.HIDE_NO_DETAILS_AVAILABLE_POPUP });

export const showCreatePresumedResultPopup = dispatch => presumedResultDetails => {
    dispatch({
        type: TYPES.SHOW_CREATE_PRESUMED_RESULT_POPUP,
        payload: {
            presumedResultDetails,
        },
    });
};

export const hideCreatePresumedResultPopup = dispatch => () => {
    dispatch({ type: TYPES.HIDE_CREATE_PRESUMED_RESULT_POPUP });
};

export const showDeletePresumedResultPopup = dispatch => presumedResultDetails => {
    dispatch({
        type: TYPES.SHOW_DELETE_PRESUMED_RESULT_POPUP,
        payload: {
            presumedResultDetails,
        },
    });
};

export const hideDeletePresumedResultPopup = dispatch => () => {
    dispatch({ type: TYPES.HIDE_DELETE_PRESUMED_RESULT_POPUP });
};

export const showOrfG5BoyFormPopup = dispatch => payload => {
    dispatch({ type: TYPES.SHOW_ORF_G5_BOY_FORM_POPUP, payload });
};

export const hideOrfG5BoyFormPopup = dispatch => () => {
    dispatch({ type: TYPES.HIDE_ORF_G5_BOY_FORM_POPUP });
};

export const enableVisiblityOrfG5BoyFormPopup = dispatch => payload => {
    dispatch({ type: TYPES.ENABLE_VISIBILITY_ORF_G5_BOY_FORM_POPUP, payload });
};

export const showOrfG5PMForm1AltTextPopup = dispatch => payload => {
    dispatch({ type: TYPES.SHOW_ORF_G5_PM_FORM1_ALT_TEXT_POPUP, payload });
};

export const hideOrfG5PMForm1AltTextPopup = dispatch => () => {
    dispatch({ type: TYPES.HIDE_ORF_G5_PM_FORM1_ALT_TEXT_POPUP });
};

export const showDigitalPopup = dispatch => payload => {
    dispatch({ type: TYPES.SHOW_DIGITAL_FORMS_POPUP, payload });
};

export const hideDigitalPopup = dispatch => () => {
    dispatch({ type: TYPES.HIDE_DIGITAL_FORMS_POPUP });
};

export const enableVisiblityDigitalPopup = dispatch => payload => {
    dispatch({ type: TYPES.ENABLE_VISIBILITY_DIGITAL_FORMS_POPUP, payload });
};

export const showTRCOutsideBMPopup = dispatch => payload => {
    dispatch({ type: TYPES.SHOW_TRC_OUTSIDE_BM_POPUP, payload });
};

export const hideTRCOutsideBMPopup = dispatch => () => {
    dispatch({ type: TYPES.HIDE_TRC_OUTSIDE_BM_POPUP });
};

export const showNoIDELSupportPopup = dispatch => () => {
    dispatch({ type: TYPES.SHOW_NO_IDEL_SUPPORT_POPUP });
};

export const hideNoIDELSupportPopup = dispatch => () => {
    dispatch({ type: TYPES.HIDE_NO_IDEL_SUPPORT_POPUP });
};
